import React from 'react';
import { NavLink } from 'react-router-dom';

function Sidebar({ isSidebarOpen, setIsSidebarOpen }) {
  const linkClass = "flex items-center gap-3 rounded-lg px-3 py-2 text-text-color hover:bg-black/5";
  const activeLinkClass = "flex items-center gap-3 rounded-lg bg-primary/20 px-3 py-2 text-primary";

  return (
    <>
      <aside 
        className={`fixed top-0 left-0 z-40 flex h-screen min-w-[240px] md:min-w-[220px] flex-col justify-between border-r border-border-color bg-sidebar-bg/95 p-3 transition-transform duration-300
        ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"}
        md:sticky md:z-auto md:translate-x-0`}
      >
        <div className="flex flex-col gap-4">
          <div className="flex items-center justify-between gap-2 px-2">
            <div className="flex items-center gap-2">
              <div
                className="size-9 rounded-full bg-slate-200 flex-shrink-0"
                data-alt="Karnataka Government Emblem"
              >
                {/* === THIS IS THE CHANGE === */}
                <img
                  alt="Karnataka Government Emblem"
                  className="h-full w-full object-contain"
                  src="/logo.png" 
                />
                {/* ========================= */}
              </div>
              <div className="flex flex-col">
                <h1 className="text-sm font-medium leading-tight text-text-color">
                  Govt. of Karnataka
                </h1>
                <p className="text-xs font-normal leading-tight text-text-color/70">
                  Mines & Geology
                </p>
              </div>
            </div>
            {/* === FIX: Added the missing close button from my context === */}
            <button
              onClick={() => setIsSidebarOpen(false)}
              className="text-text-color md:hidden"
            >
              <span className="material-symbols-outlined">close</span>
            </button>
          </div>
          
          {/* === FIX: Added the missing NavLink elements === */}
          <nav className="mt-4 flex flex-col gap-2">
            <NavLink
              to="/dashboard"
              className={({ isActive }) =>
                isActive ? activeLinkClass : linkClass
              }
            >
              <span className="material-symbols-outlined text-base">
                dashboard
              </span>
              <p className="text-sm font-medium leading-normal">Dashboard</p>
            </NavLink>

            <NavLink to="/" className={linkClass}>
              <span className="material-symbols-outlined text-base">
                search
              </span>
              <p className="text-sm font-medium leading-normal">
                Find Application
              </p>
            </NavLink>
          </nav>
        </div>

        {/* === FIX: Added the missing footer div === */}
        <div className="flex flex-col gap-1">{/* Logout button slot */}</div>
      </aside>

      {/* === FIX: Added the missing mobile overlay div === */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 z-30 bg-black/50 md:hidden"
          onClick={() => setIsSidebarOpen(false)}
        ></div>
      )}
    </>
  );
}

export default Sidebar;
